import { AfterContentChecked, ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { LoadingService } from './services/shared/loading.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, AfterContentChecked {
  title = 'frontend';
  HTTPActivity: boolean;

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.loadingService.loadingRequests.length = 0;
  }

  constructor(
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly cdr: ChangeDetectorRef,
    public loadingService: LoadingService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('en');
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      
      rt.data.subscribe((data) => {
        if (data.title) {
          const path = globalThis.location.pathname;
          const personaTitle = localStorage.getItem('personaTitle');

          if (path.includes('/persona/') && personaTitle) {
            this.titleService.setTitle(
              personaTitle + ` > ${this.translate.instant(data.title)} | NJO`
            );
          } else {
            this.titleService.setTitle(`${this.translate.instant(data.title)} | NJO`);
          }
        }
      });
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
